module.exports = __webpack_public_path__ + "static/media/37-10.355467c8.mp3";